<template>
  <div>
    <v-text-field
      v-model="dashboardName"
      :label="$t('dashboard.fields.name')"
    />

    <v-autocomplete
      v-model="selectedTemplate"
      :items="templates"
      :label="$t('templateDashboard.selectDashboard')"
      item-text="name"
      item-value="templateDashboardId"
      @change="setupItemsFromWidgets"
    />

    <template-dashboard-slot-selector v-model="items" />

    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        text
        x-large
        @click="save"
        :disabled="!(selectedTemplate && dashboardName)"
        >{{ $t("common.create") }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { templateDashboardTypes } from "../../_helpers/templateDashboardHelper";
import TemplateDashboardSlotSelector from "@/components/db/TemplateDashboardSlotSelector.vue";
import { DashboardTypes } from "@/_helpers/CsharpEnum";

export default {
  name: "TemplateDashboardCreationForm",

  components: {
    TemplateDashboardSlotSelector,
  },

  props: {
    categoryId: {
      type: String,
      default: "00000000-0000-0000-0000-000000000000",
    },
  },

  data() {
    return {
      templates: [],
      selectedTemplate: "",
      dashboardName: "",
      items: [],
    };
  },

  computed: {
    ...mapState("templateDashboard", ["widgets", "globalWidgets"]),

    widgetSlots() {
      return this.widgets?.flatMap((x) => x.slots) ?? [];
    },
  },

  methods: {
    ...mapActions("templateDashboard", [
      "getTemplateDashboards",
      "getTemplateDashboard",
      "getDashboardWidgets",
      "reset",
    ]),
    ...mapActions("dashboards", ["create"]),
    ...mapActions("alert", ["success", "error"]),

    async save() {
      //Construct payload
      let payload = {
        name: this.dashboardName,
        categoryId:
          this.categoryId != "00000000-0000-0000-0000-000000000000"
            ? this.categoryId
            : undefined,
        templateDashboardItems: this.items,
        templateDashboardId: this.selectedTemplate,
      };

      var result = await this.create({
        payload: payload,
        dashboardType: DashboardTypes.TEMPLATE,
      });

      if (result !== true) {
        this.error(this.$t("common.error"));
        return;
      }
      this.success(this.$t("templateDashboard.createdSuccess"));
      this.$emit("save");
    },

    async setupItemsFromWidgets(templateDashboardId) {
      if (
        templateDashboardId == undefined ||
        templateDashboardId == null ||
        templateDashboardId == ""
      ) {
        this.reset();
        return;
      }

      await this.getTemplateDashboard(templateDashboardId);
      await this.getDashboardWidgets(templateDashboardId);

      this.items = [];
      for (let i = 0; i < this.widgetSlots.length; i++) {
        let item = this.items.find((x) => x.index == this.widgetSlots[i].index);

        // If this Item doesn't exist => Add a new item and add this slot to it's slotKeys
        // Items are per index ("Deveui Slot")
        if (item == undefined) {
          this.items.push({
            index: this.widgetSlots[i]?.index,
            tagId: "",
            templateDashboardId: templateDashboardId,
            slotKeys: [
              {
                key: "",
                slotId: this.widgetSlots[i]?.slotId,
                slotDescription: this.widgetSlots[i]?.slotDescription,
              },
            ],
          });
          continue;
        }

        // If this Item exist => Add this slot to its slotKeys
        if (
          item.slotKeys.find((x) => x.slotId == this.widgetSlots[i]?.slotId) ==
          undefined
        )
          item.slotKeys.push({
            key: "",
            slotId: this.widgetSlots[i]?.slotId,
            slotDescription: this.widgetSlots[i]?.slotDescription,
          });
      }
    },
  },

  async created() {
    this.templates = (await this.getTemplateDashboards(false)).filter(
      (x) => x.type == templateDashboardTypes.Full.value
    );
  },
};
</script>
